// extracted by mini-css-extract-plugin
export default {"text-shadow":"text-shadow--8aQV1","textShadow":"text-shadow--8aQV1","in-header":"in-header--hq-mE","inHeader":"in-header--hq-mE"};